import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import MaterialTable from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import { Card } from '../Card';

const PREFIX = 'Table';

const classes = {
  root: `${PREFIX}-root`
};

const StyledCard = styled(Card)({
  [`& .${classes.root}`]: {
    minWidth: 500,
    width: '100%',
  },
});

const StyledTable = MaterialTable;

export default function Table({
  rows,
  renderHeader,
  renderRow,
  RowsPlaceholderComponent,
  className,
}) {
  return (
    (<StyledCard className={className}>
      <StyledTable
        classes={{
          root: classes.root
        }}>
        {renderHeader && <TableHead>{renderHeader()}</TableHead>}
        <TableBody>{rows.map(renderRow)}</TableBody>
        {isEmpty(rows) && RowsPlaceholderComponent && (
          <TableBody>{RowsPlaceholderComponent}</TableBody>
        )}
      </StyledTable>
    </StyledCard>)
  );
}

Table.propTypes = {
  rows: PropTypes.array.isRequired,
  renderHeader: PropTypes.func,
  renderRow: PropTypes.func,
  RowsPlaceholderComponent: PropTypes.node,
  className: PropTypes.string,
};
